'use client';
import { useAuth } from '../contexts/AuthContext';
import { useConsentStatus } from '@practium/features/api';

export const useConsentPending = (): boolean => {
	const { isAuthenticated, isLoading: authLoading } = useAuth();
	const { data: consentStatus, isLoading: consentLoading } = useConsentStatus(
		isAuthenticated && !authLoading
	);

	if (!isAuthenticated || authLoading || consentLoading) return false;
	return consentStatus !== undefined && !consentStatus.allGranted;
};
